import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';
import { cn } from '@/utils/cnUtils';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { JournalEntryStatus } from '@/api/models';
import { JOURNAL_STATUS_CHIP } from '../../journalMeta';

type JournalStatusChipProps = {
    status: JournalEntryStatus;
    /** testid discriminator (entry id). */
    slot: string;
};

/** Soft status pill with a leading state dot. */
export const JournalStatusChip: React.FC<JournalStatusChipProps> = ({
    status,
    slot,
}) => {
    const { t } = useTranslation('pages');
    const config = JOURNAL_STATUS_CHIP[status];

    return (
        <Chip
            className={cn(config.className, 'border-0')}
            size="sm"
            variant="soft"
            {...getNodeTestIdProp(`journal-status-${slot}`)}
        >
            <Chip.Label className="flex items-center gap-1.5">
                <span
                    aria-hidden
                    className="size-1.5 rounded-full bg-current opacity-70"
                />
                {t(config.labelKey)}
            </Chip.Label>
        </Chip>
    );
};
